import React, { useContext, useEffect, useState } from "react";
import styles from "./Test.module.scss";
import PathContext from "../../context/path";
import { Link } from 'react-router-dom';
import clsx from 'clsx';

const Test = (props) => {
  const { question, answers, rightAnswer, resultTitles, resultText, img, color, className } = props;
  const [isAnswered, setAnswered] = useState(false);
  const [answerIndex, setAnswerIndex] = useState(-1);
  const path = useContext(PathContext);
  let wrapClass = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  let title = null;
  let inner = null;

  useEffect(() => {
    let array = [img, `${img}-mobile`, `${img}-answer`, `${img}-answer-mobile`];
    array.forEach(element => {
      const img = new Image();
      img.src = `${path}/img/${element}.svg`;
    });
  }, [img, path]);
  const getAnswer = (number) => {
    setAnswerIndex(number);
    setAnswered(true);
  }
  if (isAnswered && answerIndex >= 0) {
    title = resultTitles[answerIndex];
    let texts = [];
    if (resultText !== undefined && resultText.length > 0 && resultText[answerIndex] !== undefined) {
      resultText[answerIndex].forEach((element, index) => {
        let link = null;
        if (index === resultText[answerIndex].length - 1) {
          link = <> 
          {/* <a href='https://spb.hh.ru/employer/8121' target='_blank'  rel="noreferrer">Посмотрите вакансии?</a> */}
          <Link to={{pathname: '../vacancies', search: window.location.search}}>Посмотрите вакансии?</Link>
          </>;
        }
        let text = <p key={`answer-text-${index}`}>{element} {link}</p>
        texts.push(text);
      });
    }
    inner = <div className={styles.text} data-answer-text={true}>
      {texts}
    </div>
  } else {
    title = question;
    let answerBtns = [];
    if (answers !== undefined && answers.length > 0) {
      answers.forEach((element, index) => {
        let answer = <div className={styles.answer} key={`answer-btn-${index}`} onClick={() => { getAnswer(index) }}>{element}</div>
        answerBtns.push(answer);
      });
    }
    inner = <div className={styles.answers}>
      {answerBtns}
    </div>
  }
  let imgSrc = img;
  if (isAnswered) {
    imgSrc += '-answer';
  }
  let imgElement = <picture>
    <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${imgSrc}-mobile.svg`} />
    <img src={`${path}/img/${imgSrc}.svg`} alt="" />
  </picture>
  // if (img !== 'alexandra-test-1' && img !== 'alexandra-test-2') {
  //   imgElement = <picture>
  //     <source media="screen and (max-width: 767px)" srcSet={`${path}/img/test-mobile.webp`} />
  //     <img src={`${path}/img/${img}.svg`} alt="" />
  //   </picture>
  // }
  return (
    <>
      <div className={clsx(wrapClass, className)} data-animate={'fade-in-up'} data-header-trigger={true}>
        <div className={styles.body}>
          <div className={styles.title} data-test-title={true}>{title}</div>
          <div className={styles.inner}>
            {inner}
          </div>
        </div>
        {/* <div className={styles.figure}>
          <svg width="255" height="334" viewBox="0 0 255 334" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M367.472 146.126L242.565 21.2197C215.934 -5.41133 172.757 -5.41133 146.126 21.2197L21.2197 146.126C-5.41131 172.757 -5.41132 215.934 21.2197 242.565L146.126 367.472C172.757 394.103 215.934 394.103 242.565 367.472L367.472 242.565C394.103 215.934 394.103 172.757 367.472 146.126Z" stroke="white" strokeMiterlimit="10" />
          </svg>

        </div> */}
        <div className={styles.img} key={`img-${isAnswered}`}>
          {imgElement}
        </div>
      </div>
    </>
  );

}

export default Test;
